export default __webpack_public_path__ + "static/media/transaction-active.4a35e4d7.svg";